import React, { useState } from 'react';
import { Button } from 'antd';
import { Col, Row } from 'reactstrap';
import StickerCategory from './components/StickerCategory';

const ExamplePage = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [update, setUpdate] = useState(0);

  const openAddModal = () => {
    setUpdate(update + 1);
    setModalVisible(true);
  }

  return (
    <div className="dashboard-container">
      <Row>
        <Col md={12}>
          <div style={{justifyContent: 'space-between', display: 'flex'}}>
            <h3 className="page-title">Sticker Category</h3>
            <Button type="text" onClick={() => openAddModal()}>Add Category</Button>
          </div>
        </Col>
      </Row>
      <Row>
        <StickerCategory setModalVisible={(value) => setModalVisible(value)} modalVisible={modalVisible} setUpdate={(value) => setUpdate(value)} update={update} />
      </Row>
    </div>
  )
};

export default ExamplePage;
